import { render, staticRenderFns } from "./DeleteQuoteButton.vue?vue&type=template&id=84282b00"
import script from "./DeleteQuoteButton.vue?vue&type=script&lang=js"
export * from "./DeleteQuoteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports